<template>
	<div class="card">
		<div class="card-header">
			Data Presensi
			<el-tooltip placement="right" content="Lihat data presensi">
				<el-button link type="primary" tag="router-link" to="presensi">
					<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
				</el-button>
			</el-tooltip>
		</div>
		<div class="card-body row align-items-center" v-loading="loading">
			<span class="col-auto mx-auto" v-if="loading">Memuat...</span>
			<span class="col-auto mx-auto" v-else-if="!logCounts.length">Data tidak ditemukan</span>
			<el-descriptions :column="1" border v-else>
				<el-descriptions-item v-for="lc in logCounts" :key="`${lc.tahun}_${lc.bulan}`" :label="lc.bulan_tahun" label-align="right">
					<div class="hstack gap-1">
						<transition name="slide-up" mode="out-in">
							<span class="fs-5" :key="lc.jumlah">{{ lc.jumlah }}</span>
						</transition>
						<span>riwayat</span>
					</div>
				</el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
export default {
	name: "DataPresensi",
	data() {
		return {
			logCounts: [],
			loading: true,
		};
	},
	mounted() {
		this.$ws.main.on("log:inserted", this.insertedLog);
		this.getJumlahLogPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("log:inserted");
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		insertedLog(data) {
			const d = JSON.parse(data);
			const scan = this.toWIB(d.waktu_presensi);
			const tahun = scan.getFullYear();
			const bulan = scan.getMonth() + 1;

			const idx = this.logCounts.findIndex((lp) => lp.tahun === tahun && lp.bulan === bulan);

			if (idx !== -1) {
				this.logCounts[idx] = {
					...this.logCounts[idx],
					jumlah: this.logCounts[idx].jumlah + 1,
				};
				return;
			}

			this.logCounts.push({
				tahun,
				bulan,
				jumlah: 1,
				bulan_tahun: new Date(scan).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
			});
		},
		async getJumlahLogPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/log/count/month");

				const logs = data.log_counts.map((l) => ({
					...l,
					bulan_tahun: new Date(l.tahun, l.bulan - 1, 1).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.logCounts = logs;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped></style>
